export default __webpack_public_path__ + "static/Commander_screenshot_composite-b2e42d2bb20f8d4f9f77198e11f08bee.jpg";